import React from 'react';
import './PracticeAreas.css';
import { Link } from 'react-router-dom';

const PracticeAreas = () => {
  const practiceAreas = [
    {
      title: 'Civil Litigation',
      icon: '⚖️',
      description: 'Comprehensive civil litigation services covering all aspects of dispute resolution.',
      areas: [
        'Contract Disputes',
        'Property Disputes',
        'Commercial Litigation',
        'Tort Claims',
        'Employment Disputes',
        'Consumer Protection'
      ],
      color: 'var(--accent-blue)'
    },
    {
      title: 'Criminal Law',
      icon: '🏛️',
      description: 'Expert criminal defense and prosecution services with thorough case preparation.',
      areas: [
        'Criminal Appeals',
        'Bail Applications',
        'White Collar Crimes',
        'Drug Offenses',
        'Assault Cases',
        'Fraud Cases'
      ],
      color: 'var(--accent-teal)'
    },
    {
      title: 'Family & Matrimonial Law',
      icon: '👨‍👩‍👧‍👦',
      description: 'Sensitive handling of family matters with compassionate legal representation.',
      areas: [
        'Divorce Proceedings',
        'Child Custody',
        'Maintenance & Alimony',
        'Adoption Cases',
        'Domestic Violence',
        'Marriage Registration'
      ],
      color: 'var(--accent-purple)'
    },
    {
      title: 'Corporate & Business Law',
      icon: '🏢',
      description: 'Complete business legal services for corporations and entrepreneurs.',
      areas: [
        'Company Formation',
        'Contract Drafting',
        'Mergers & Acquisitions',
        'Compliance Issues',
        'Intellectual Property',
        'Employment Law'
      ],
      color: 'var(--accent-orange)'
    },
    {
      title: 'Property & Real Estate',
      icon: '🏠',
      description: 'Comprehensive property law services for all real estate transactions.',
      areas: [
        'Property Documentation',
        'Title Verification',
        'Real Estate Transactions',
        'Land Acquisition',
        'Property Disputes',
        'Rental Agreements'
      ],
      color: 'var(--primary-gold)'
    },
    {
      title: 'Constitutional Law',
      icon: '📜',
      description: 'Expert handling of constitutional and administrative law matters.',
      areas: [
        'Fundamental Rights',
        'Writ Petitions',
        'Public Interest Litigation',
        'Administrative Appeals',
        'Government Disputes',
        'Constitutional Challenges'
      ],
      color: 'var(--accent-blue)'
    }
  ];

  return (
    <div className="practice-areas-page">
      {/* Hero Section */}
      <section className="practice-hero full-width-section">
        <div className="practice-hero-full-width">
          <div className="section-container">
            <div className="practice-hero-content">
              <h1 className="page-title">Practice Areas</h1>
              <p className="page-subtitle">
                Specialized legal expertise across multiple practice areas
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Practice Areas Grid */}
      <section className="practice-main full-width-section">
        <div className="section-container">
          <div className="practice-grid">
            {practiceAreas.map((area, index) => (
              <div key={index} className="practice-card">
                <div className="practice-header">
                  <div className="practice-icon" style={{'--practice-color': area.color}}>
                    {area.icon}
                  </div>
                  <h3 className="practice-title">{area.title}</h3>
                </div>
                <p className="practice-description">{area.description}</p>
                <div className="practice-areas-list">
                  <h4>Areas of Focus:</h4>
                  <div className="areas-grid">
                    {area.areas.map((subArea, idx) => (
                      <div key={idx} className="area-item">
                        <span className="area-bullet">•</span>
                        <span>{subArea}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="practice-action">
                  <Link to="/contact" className="btn btn-outline">
                    Consult Now
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="expertise-section full-width-section">
        <div className="section-container">
          <div className="expertise-content">
            <div className="expertise-text">
              <h2 className="section-title">Legal Expertise You Can Trust</h2>
              <div className="title-underline"></div>
              <p className="section-description">
                With years of experience practicing before the High Court, Ambreen Daudpota 
                brings deep legal knowledge and strategic thinking to every case. Our practice 
                covers a wide range of legal areas, ensuring comprehensive legal support for 
                individuals, families, and businesses.
              </p>
              <div className="expertise-highlights">
                <div className="highlight-item">
                  <div className="highlight-number">15+</div>
                  <div className="highlight-text">Years of Legal Experience</div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-number">6</div>
                  <div className="highlight-text">Major Practice Areas</div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-number">500+</div>
                  <div className="highlight-text">Cases Successfully Handled</div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-number">95%</div>
                  <div className="highlight-text">Client Satisfaction Rate</div>
                </div>
              </div>
            </div>
            <div className="expertise-visual">
              <div className="expertise-card">
                <h4>Our Commitment</h4>
                <div className="commitment-list">
                  <div className="commitment-item">
                    <div className="commitment-icon">🎯</div>
                    <span>Strategic Legal Solutions</span>
                  </div>
                  <div className="commitment-item">
                    <div className="commitment-icon">⚡</div>
                    <span>Timely Case Resolution</span>
                  </div>
                  <div className="commitment-item">
                    <div className="commitment-icon">🤝</div>
                    <span>Client-Centered Approach</span>
                  </div>
                  <div className="commitment-item">
                    <div className="commitment-icon">🛡️</div>
                    <span>Strong Legal Advocacy</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Court Experience Section */}
      <section className="court-experience full-width-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Court Experience</h2>
            <p className="section-subtitle">
              Extensive experience practicing before various courts and tribunals
            </p>
          </div>
          <div className="courts-grid">
            <div className="court-item">
              <div className="court-icon">🏛️</div>
              <h3>High Court</h3>
              <p>Licensed advocate with extensive High Court practice experience</p>
            </div>
            <div className="court-item">
              <div className="court-icon">⚖️</div>
              <h3>District Courts</h3>
              <p>Regular practice in civil and criminal matters at district level</p>
            </div>
            <div className="court-item">
              <div className="court-icon">🏢</div>
              <h3>Tribunals</h3>
              <p>Specialized representation before various administrative tribunals</p>
            </div>
            <div className="court-item">
              <div className="court-icon">📋</div>
              <h3>Appellate Courts</h3>
              <p>Experienced in handling appeals and appellate proceedings</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="practice-cta full-width-section">
        <div className="section-container">
          <div className="cta-content">
            <h2>Need Legal Assistance?</h2>
            <p>Get expert legal advice tailored to your specific situation. Contact us for a consultation.</p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">Schedule Consultation</Link>
              <Link to="/services" className="btn btn-secondary">View All Services</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PracticeAreas;
